/* MASONTEX · shared inquiry controller
   Generic forms route sample intent into the canonical Unified Request page.
   The Unified Request page itself owns direct-sample readiness and payment state. */
(() => {
  'use strict';
  if (window.__MS_UNIFIED_INQUIRY_CONTROLLER__) return;
  window.__MS_UNIFIED_INQUIRY_CONTROLLER__ = true;

  const SAMPLE_FLOW_PATH = '/pages/order-a-sample';
  const q = (root, selector) => root.querySelector(selector);
  const clean = (value = '') => String(value || '').trim();

  const init = (root) => {
    if (!root || root.dataset.msUnifiedReady === '1') return;
    root.dataset.msUnifiedReady = '1';

    const form = q(root, 'form');
    if (!form) return;

    /* On the canonical request page, ms-sample-request.js is the sole sample-action owner. */
    if (root.closest('[data-ms-sample-request]')) return;

    const sample = q(root, '[data-ms-unified-sample]');
    const handle = q(root, '[data-ms-unified-handle]');
    const model = q(root, '[data-ms-unified-model]');
    const product = q(root, '[data-ms-unified-product]');

    const buildSampleRequestUrl = () => {
      const params = new URLSearchParams({ intent: 'sample', source: 'form' });
      const productHandle = clean(handle?.value);
      const modelValue = clean(model?.value || product?.value);
      if (productHandle) params.set('product', productHandle);
      if (modelValue) params.set('model', modelValue);
      return `${SAMPLE_FLOW_PATH}?${params.toString()}`;
    };

    const sync = () => {
      if (!sample) return;
      sample.hidden = false;
      sample.href = buildSampleRequestUrl();
      sample.dataset.msCheckoutEnabled = 'false';
    };

    [handle, model, product].forEach((field) => {
      field?.addEventListener('input', sync);
      field?.addEventListener('change', sync);
    });
    sync();
  };

  const boot = (scope = document) => scope.querySelectorAll('[data-ms-unified-inquiry]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => boot(), { once: true });
  else boot();
  document.addEventListener('shopify:section:load', (event) => boot(event.target));
})();
